import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Views} from '@ccp/config/views';
import {EnquirusService} from '@ccp/services/enquirus/enquirus.service';

export const EnquirusActivatedGard: CanActivateFn = (route) => {
  const enquirusService = inject(EnquirusService);
  const router = inject(Router);

  if (enquirusService.isEnabled$()) {
    return true;
  }

  const createRedirect = (path: string) =>
    router.createUrlTree([path], {
      queryParams: {...route.queryParams},
    });

  return createRedirect(Views.myEnquirusNotAvailable.path);
};
